
import Auth from '../components/auth';

export default function AuthPage() {

  return (
    <Auth view={"signIn"} />
  );
};
